import {useAuth} from '../contexts/AuthContext';

export function usePermissions() {
  const {user} = useAuth();

  const roles = user?.roles ?? (user?.role ? [user.role] : []);
  const isAdmin = roles.includes('admin');
  const isModerator = roles.includes('moderator');
  const isTrainer = roles.includes('trainer');
  const isUser = roles.includes('user');

  const can = (permission: string): boolean => {
    if (isAdmin) return true;
    // Add fine-grained permission checks here if backend sends permissions array
    return false;
  };

  const hasRole = (role: string): boolean => roles.includes(role);
  const hasAnyRole = (required: string[]): boolean => required.some((r) => roles.includes(r));

  return {roles, isAdmin, isModerator, isTrainer, isUser, can, hasRole, hasAnyRole};
}
